import { jsx as m } from "react/jsx-runtime";
import t, { useState as i, useCallback as l, useMemo as x } from "react";
import { c as u } from "../clsx-OuTLNxxd.js";
const E = "Accordion-module_wrapper__k5R-U",
  f = {
    wrapper: E
  },
  v = _ref => {
    let {
      className: a,
      trackingName: p,
      children: n
    } = _ref;
    const [o, r] = i(void 0),
      s = l(e => {
        o == e ? r(void 0) : r(e);
      }, [o]),
      c = x(() => t.Children.map(n, e => {
        if (t.isValidElement(e)) {
          const d = o == e.props.id;
          return t.cloneElement(e, {
            onToggleExpanedItem: s,
            isExpanded: d
          });
        }
      }), [n, o, s]);
    return /* @__PURE__ */m("div", {
      "data-content-name": p,
      className: u(f.wrapper, a),
      children: c
    });
  };
export { v as Accordion };